module.exports = __webpack_public_path__ + "default-868cc0aab778a1d63db3.svg";